/* unplugin-vue-components disabled */import script from "./imageTextCard.vue?vue&type=script&setup=true&lang=js"
export * from "./imageTextCard.vue?vue&type=script&setup=true&lang=js"

import "./imageTextCard.vue?vue&type=style&index=0&id=4eedc3de&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4eedc3de"]])

export default __exports__